module.exports = __webpack_public_path__ + "img/logo-17.69ea731.jpg";